<template>
  <div class='loading-spinner'>
    <lottie-animation
      ref="anim"
      :animationData="require('@/assets/icons/animations/data-loader.json')"
      :loop="true"
      :style="styleProperty"
    />
    <span class='spinner-label' v-if="!progress > 0"> {{ (label || $t('loading.spinner.label')) }} </span>
    <div class="spinner-progress" v-if="progress > 0">
      <custom-progress-bar
        :progress="getProgress"
        :label=" (label || $t('loading.spinner.label'))"
      />
    </div>
  </div>
</template>

<script>
import LottieAnimation from 'lottie-web-vue';
import CustomProgressBar from '@/components/common/CustomProgresBar.vue';

export default {
  name: 'LoadingSpinner',
  props: {
    label: {
      type: String,
      required: false,
    },
    height: {
      required: false,
      type: String,
      default: '250',
    },
    progress: {
      required: false,
      type: Number,
      default: 0,
    },
  },
  components: {
    CustomProgressBar,
    LottieAnimation,
  },
  computed: {
    styleProperty() {
      return `height: ${this.height}px`;
    },
    getProgress() {
      return parseInt(this.progress, 10);
    },
  },
};
</script>

<style lang='scss' scoped>
@import '~@/assets/styles/design-system';

.loading-spinner {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  stroke: var(--bg-primary);
  stroke-width: 1px;

  // Element UI progress bar override
  :deep(.el-progress--line) {
    .el-progress-bar {
      &__innerText {
        font-family: $font-family-medium;
      }
    }
  }
}

.spinner-label {
  color: var(--brand-primary);
  font-family: $font-family-semibold;
  font-size: $font-size-lg;
  letter-spacing: 0.07em;
  margin-top: -$space-10; // Pull label up closer to animation
}

.spinner-progress {
  width: 15.625rem; // 250px
  margin-top: -$space-8; // Pull progress bar up closer to animation
}
</style>
